import { render, staticRenderFns } from "./depot.vue?vue&type=template&id=9326cbb4"
import script from "./depot.vue?vue&type=script&lang=tsx"
export * from "./depot.vue?vue&type=script&lang=tsx"
import style0 from "./depot.vue?vue&type=style&index=0&id=9326cbb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports